import type { TypedWrappedFieldProps } from "redux-form";
import { Field } from "redux-form";

import { Divider, Typography } from "@braintrust/braintrust-ui-components";
import { FieldSectionPanelWithImportance } from "@js/apps/jobs/forms/fields/field-section-panel";
import type { CommonLexicalEditorProps } from "@js/components/rich-text-editor/common-editor/common-editor";
import { RichTextareaField } from "@js/forms/fields/rich-textarea";
import { shouldDisplayError } from "@js/forms/utils";

import { OFFER_FIELDS } from "../../constants";

export const AdditionalTerms = () => {
  return (
    <Field
      name={OFFER_FIELDS.additional_contract_terms}
      component={AdditionalTermsComponent}
    />
  );
};

type AdditionalTermsComponentProps = TypedWrappedFieldProps<string>;
const AdditionalTermsComponent = ({
  input,
  meta,
}: AdditionalTermsComponentProps) => {
  const displayError = shouldDisplayError({ input, meta });
  return (
    <FieldSectionPanelWithImportance
      title="📑 Additional terms"
      isError={displayError}
      fieldImportance="optional"
    >
      <Divider color="beige" sx={{ my: 2 }} />
      <Typography
        component="p"
        variant="paragraph"
        sx={{ overflowWrap: "anywhere", mb: 2 }}
      >
        Include specifics like invoicing cadence, deliverables, approval
        requirements, or communication expectations.
      </Typography>
      <RichTextareaField
        id="additional-terms"
        input={input}
        meta={meta}
        placeholder="Add details to clarify expectations — such as invoicing schedule, deliverables, or review process."
        hideError
        maxHeight={1000}
        toolbar={toolbar}
      />
    </FieldSectionPanelWithImportance>
  );
};

const toolbar: CommonLexicalEditorProps["toolbar"] = [
  ["bold", "italic", "underline"],
  ["format"],
  ["align-left", "align-center", "align-right"],
  ["list", "indent"],
  ["emoji", "clear-formatting"],
  ["undo", "redo"],
] as const;
